module.exports = __webpack_public_path__ + "static/img/lv0.56ccfdff.png";